import React from 'react';
import { withStyles } from '@jpmuitk/theme';

import { styles } from './styles';

const Tag = ({ classes, children, type }) => <span className={classes.root}>{children}</span>;

export default withStyles(styles)(Tag);
